import React from 'react'
import { withIcon } from '../../withIcon'

function OdnoklassnikiIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12.0869 2C9.1389 2 6.74914 4.32042 6.74914 7.18271C6.74914 10.0451 9.1389 12.3657 12.0869 12.3657C15.0349 12.3657 17.4247 10.0451 17.4247 7.18271C17.4247 4.32042 15.0349 2 12.0869 2ZM12.0869 9.32528C10.8683 9.32528 9.88038 8.36599 9.88038 7.18279C9.88038 5.99959 10.8683 5.04037 12.0869 5.04037C13.3055 5.04037 14.2934 5.99959 14.2934 7.18279C14.2934 8.36599 13.3055 9.32528 12.0869 9.32528Z" stroke={color}/>
      <path d="M13.9713 16.7074C16.1083 16.2847 17.3888 15.3021 17.4566 15.2494C18.0819 14.7625 18.1823 13.8756 17.6808 13.2683C17.1794 12.6612 16.2661 12.5637 15.6406 13.0505C15.6274 13.0609 14.2616 14.0782 12.0144 14.0797C9.76724 14.0782 8.37257 13.0609 8.35935 13.0505C7.7339 12.5637 6.82054 12.6612 6.31914 13.2683C5.81766 13.8756 5.91811 14.7625 6.54341 15.2494C6.61208 15.3028 7.94549 16.311 10.1423 16.7238L7.08064 19.8305C6.52424 20.3908 6.54096 21.2829 7.11799 21.8231C7.39963 22.0868 7.76262 22.2178 8.1253 22.2178C8.50556 22.2178 8.88543 22.0736 9.1702 21.7868L12.0145 18.8449L15.146 21.8058C15.7134 22.3559 16.6322 22.355 17.1985 21.8043C17.7649 21.2535 17.7642 20.3613 17.1969 19.8114L13.9713 16.7074Z" stroke={color}/>
    </svg>
  )
}

export default withIcon(OdnoklassnikiIcon)
